<template>
  <div class="content">
    <div>
      <h2 class="page-title">発注履歴</h2>
      <!-- 検索項目 -->
      <h4 class="page-sub-title pl-2 pl-md-4">検索</h4>
      <section id="history-search">
        <div class="section-child p-2">
          <div class="row pb-1 mx-0">
            <div class="col-md-4">
              <div class="row">
                <label class="col-md-form-label col-md-5 pt-2 px-0 px-md-3 m-0">
                  貴社管理番号
                </label>
                <input
                  type="text"
                  class="form-control col-md-6"
                  name="MNG_NO"
                  id="MNG_NO"
                  v-model="$store.state.history.MNG_NO"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="row">
                <label class="col-md-form-label col-md-4 pt-2 px-0 px-md-3 m-0">
                  車名
                </label>
                <input
                  type="text"
                  class="form-control col-md-7"
                  name="CAR_NAME"
                  id="CAR_NAME"
                  v-model="$store.state.history.CAR_NAME"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="row">
                <label class="col-md-form-label col-md-4 pt-2 px-0 px-md-3 m-0">
                  車台番号
                </label>
                <input
                  type="text"
                  class="form-control col-md-7"
                  name="CAR_NO"
                  id="CAR_NO"
                  v-model="$store.state.history.CAR_NO"
                />
              </div>
            </div>
          </div>

          <Accordion title="詳細検索" class="accordion" ref="search_accordion">
            <div class="row pb-2 mx-0">
              <div class="col-md-4">
                <div class="row">
                  <label
                    class="col-md-form-label col-md-5 pt-2 px-0 px-md-3 m-0"
                  >
                    登録番号
                  </label>
                  <input
                    type="text"
                    class="form-control col-md-6"
                    name="TOUROKU_NO"
                    id="TOUROKU_NO"
                    v-model="$store.state.history.TOUROKU_NO"
                  />
                </div>
              </div>
              <div class="col-md-4">
                <div class="row">
                  <label
                    class="col-md-form-label col-md-4 pt-2 px-0 px-md-3 m-0"
                  >
                    引取先
                  </label>
                  <input
                    type="text"
                    class="form-control col-md-7"
                    name="HIKITORI_SAKI"
                    id="HIKITORI_SAKI"
                    v-model="$store.state.history.HIKITORI_SAKI"
                  />
                </div>
              </div>
              <div class="col-md-4">
                <div class="row">
                  <label
                    class="col-md-form-label col-md-4 pt-2 px-0 px-md-3 m-0"
                  >
                    納車先
                  </label>
                  <input
                    type="text"
                    class="form-control col-md-7"
                    name="NOUHIN_SAKI"
                    id="NOUHIN_SAKI"
                    v-model="$store.state.history.NOUHIN_SAKI"
                  />
                </div>
              </div>
            </div>
            <div class="row pb-2 mx-0">
              <div class="col-lg-4">
                <div class="row">
                  <label
                    class="
                      col-md-form-label col-md-3 col-lg-5
                      pt-2
                      px-0 px-md-3
                      m-0
                    "
                  >
                    ロジコ管理番号
                  </label>
                  <input
                    type="text"
                    class="form-control col-md-4 col-lg-6"
                    name="LOGICO_MNG_NO"
                    id="LOGICO_MNG_NO"
                    v-model="$store.state.history.LOGICO_MNG_NO"
                  />
                </div>
              </div>
            </div>
            <div class="row pb-2 mx-0">
              <div class="col-lg-6">
                <div class="row">
                  <label
                    class="col-md-form-label col-md-3 pt-2 px-0 px-md-3 m-0"
                  >
                    ご注文日
                  </label>
                  <DatePicker
                    id="ORDER_DATE_FROM"
                    name="ORDER_DATE_FROM"
                    clearable
                    format="YYYY-MM-DD"
                    class="ml-md-3 col-md-4 p-0"
                    v-model="orderDateFrom"
                  />
                  <span class="ml-3 ml-md-0 p-md-2">〜</span>
                  <DatePicker
                    id="ORDER_DATE_TO"
                    name="ORDER_DATE_TO"
                    clearable
                    format="YYYY-MM-DD"
                    class="col-md-4 p-0"
                    v-model="orderDateTo"
                  />
                </div>
              </div>
              <div class="col-lg-6 mt-3 mt-lg-0">
                <div class="row">
                  <label
                    :class="[
                      'col-md-form-label col-md-2 col-lg-3 pt-2 px-0 px-md-3 m-0',
                      { 'text-right': isPC },
                    ]"
                  >
                    引取予定日
                  </label>
                  <DatePicker
                    id="HIKITORI_YOTEI_DATE_FROM"
                    name="HIKITORI_YOTEI_DATE_FROM"
                    clearable
                    class="ml-md-3 col-md-4 p-0"
                    v-model="hikitoriYoteiDateFrom"
                  />
                  <span class="ml-3 ml-md-0 p-md-2">〜</span>
                  <DatePicker
                    id="HIKITORI_YOTEI_DATE_TO"
                    name="HIKITORI_YOTEI_DATE_TO"
                    clearable
                    class="col-md-4 p-0"
                    v-model="hikitoriYoteiDateTo"
                  />
                </div>
              </div>
            </div>
            <div class="row pb-2 mx-0">
              <div class="col-lg-6">
                <div class="row">
                  <label
                    class="
                      col-md-form-label col-md-2 col-lg-3
                      pt-2
                      px-0 px-md-3
                      m-0
                    "
                  >
                    納車予定日
                  </label>
                  <DatePicker
                    id="NOUSYA_YOTEI_DATE_FROM"
                    name="NOUSYA_YOTEI_DATE_FROM"
                    clearable
                    class="ml-md-3 col-md-4 p-0"
                    v-model="nosyaYoteiDateFrom"
                  />
                  <span class="ml-3 ml-md-0 p-md-2">〜</span>
                  <DatePicker
                    id="NOUSYA_YOTEI_DATE_TO"
                    name="NOUSYA_YOTEI_DATE_TO"
                    clearable
                    class="col-md-4 p-0"
                    v-model="nosyaYoteiDateTo"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-9 px-4 pt-2">
              <div class="row">
                <label
                  class="
                    col-md-form-label col-md-12 col-lg-2
                    pt-2
                    px-0 px-md-3
                    m-0
                  "
                >
                  種別
                </label>
                <div class="mt-md-2">
                  <div class="form-check form-check-inline">
                    <md-checkbox
                      class="form-check-input md-primary ml-lg-3"
                      v-model="$store.state.history.YUSOU_SYUBETSU"
                      value="0"
                    >
                      輸送のみ
                    </md-checkbox>
                  </div>
                  <div class="form-check form-check-inline">
                    <md-checkbox
                      class="form-check-input md-primary"
                      v-model="$store.state.history.YUSOU_SYUBETSU"
                      value="1"
                    >
                      名変輸送
                    </md-checkbox>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-9 px-4 pt-2">
              <div class="row">
                <label
                  class="
                    col-md-form-label col-md-3 col-lg-2
                    pt-2
                    px-0 px-md-3
                    m-0
                  "
                >
                  ステータス
                </label>
                <div class="mt-md-2">
                  <div class="form-check form-check-inline">
                    <md-checkbox
                      class="form-check-input md-primary ml-lg-3"
                      v-model="$store.state.history.STATUS"
                      :value="1"
                    >
                      調整中
                    </md-checkbox>
                  </div>
                  <div class="form-check form-check-inline">
                    <md-checkbox
                      class="form-check-input md-primary"
                      v-model="$store.state.history.STATUS"
                      :value="5"
                    >
                      受注完了
                    </md-checkbox>
                  </div>
                  <div class="form-check form-check-inline">
                    <md-checkbox
                      class="form-check-input md-primary"
                      v-model="$store.state.history.STATUS"
                      :value="2"
                    >
                      手配完了
                    </md-checkbox>
                  </div>
                  <div class="form-check form-check-inline">
                    <md-checkbox
                      class="form-check-input md-primary"
                      v-model="$store.state.history.STATUS"
                      :value="3"
                    >
                      引取完了
                    </md-checkbox>
                  </div>
                  <div class="form-check form-check-inline">
                    <md-checkbox
                      class="form-check-input md-primary"
                      v-model="$store.state.history.STATUS"
                      :value="4"
                    >
                      納車完了
                    </md-checkbox>
                  </div>
                  <div class="form-check form-check-inline">
                    <md-checkbox
                      class="form-check-input md-primary"
                      v-model="$store.state.history.STATUS"
                      :value="9"
                    >
                      キャンセル
                    </md-checkbox>
                  </div>
                </div>
              </div>
            </div>
          </Accordion>
          <div class="text-right mt-3 mt-md-0">
            <b-button
              class="btn btn-success mr-2 p-0"
              @click="
                forcePageFirst()
                search()
              "
            >
              検索
            </b-button>
            <b-button class="btn btn-secondary mr-2 p-0" @click="resetForm">
              リセット
            </b-button>
          </div>
        </div>
      </section>

      <!-- 検索一覧 -->
      <h4 class="page-sub-title pl-2 pl-md-4 mt-4">発注履歴一覧</h4>
      <select
        v-if="groups.length"
        :class="[
          'form-control col-md-5 col-10 my-2',
          isMobile ? 'm-auto' : 'ml-auto',
        ]"
        v-model="$store.state.history.JYUCYU_SHIKI_CD"
        @change="
          forcePageFirst()
          search()
        "
      >
        <option value="all" key="all">全て</option>
        <option value="" key="">
          {{ $store.state.user.data.hum_torihiki.SOFU_SAKI_MEI }}
        </option>
        <option
          v-for="(item, key) in groups"
          :value="item.JYUCYU_SHIKI_CD"
          :key="key"
        >
          {{ item.SOFU_SAKI_MEI }}
        </option>
      </select>
      <section
        id="history-list"
        class="bg-gray p-2"
        v-if="transports.length > 0 || transports_recent.length > 0"
      >
        <div class="mt-2">
          <div :class="['row mb-2', { 'mr-0': isMobile }]">
            <div class="col-md-8 mb-1">
              <b-button
                id="dl-btn"
                :class="['btn btn-success', { 'w-100': isMobile }]"
                @click="csvDownload"
              >
                実績データダウンロード
              </b-button>
            </div>
            <div class="col-md-4 mt-2 mt-md-0">
              <label class="d-inline col-5">並び替え：</label>
              <select
                class="form-control form-input d-inline col-7 mb-2 mb-md-0"
                v-model="sortKey"
                @change="
                  forcePageFirst()
                  search()
                "
              >
                <option
                  v-for="item in sortList"
                  :value="item.key"
                  :key="item.key"
                >
                  {{ item.name }}
                </option>
              </select>
            </div>
          </div>

          <paginate
            ref="paginate1"
            :page-count="getPageCount"
            :page-range="3"
            :margin-pages="2"
            :click-handler="changePage"
            :prev-text="'＜'"
            :next-text="'＞'"
            :container-class="'pagination'"
            :page-class="'page-item'"
            :page-link-class="'page-link'"
            :prev-class="'page-item'"
            :prev-link-class="'page-link'"
            :next-class="'page-item'"
            :next-link-class="'page-link'"
          />

          <b-tabs content-class="p-1 p-md-3 bg-white">
            <!-- 先月・今月 -->
            <b-tab
              title="先月・当月分"
              :active="isTabRecent"
              @click="changeTab('recent')"
            >
              <table class="table">
                <thead>
                  <tr>
                    <th>貴社管理番号</th>
                    <th>注文日</th>
                    <th>車名</th>
                    <th>引取先</th>
                    <th>引取予定日</th>
                    <th>引取完了日</th>
                    <th>合算料金</th>
                  </tr>
                  <tr>
                    <th>ロジコ管理番号</th>
                    <th>ステータス</th>
                    <th>車台番号(登録番号)</th>
                    <th>納車先</th>
                    <th>納車予定日</th>
                    <th>納車完了日</th>
                    <th>画像</th>
                  </tr>
                </thead>
                <tbody v-for="(item, index) in getItems" :key="item.id">
                  <tr :class="{ 'bg-odd': index % 2 && !isMobile }">
                    <td :class="{ 'bg-blue white': isMobile }">
                      <div class="text-right">
                        <button
                          type="button"
                          class="btn-lg btn-success md-raised pen-btn"
                          @click="editKisyaKnariBango(item)"
                        >
                          <font-awesome-icon
                            icon="pen-fancy"
                            class="pen-icon"
                          />
                        </button>
                      </div>
                      <p v-if="!isMobile">
                        {{ item.kanribango }}
                      </p>
                      <div v-else class="row">
                        <p class="col-4 bold">
                          貴社
                          <br />
                          管理番号
                        </p>
                        <p class="col-8 pl-0">{{ item.kanribango }}</p>
                      </div>
                    </td>
                    <td>
                      <p v-if="!isMobile">{{ item.chumonbi }}</p>
                      <div v-else class="row">
                        <p class="col-4 bold blue">注文日</p>
                        <p class="col-8 pl-0">{{ item.chumonbi }}</p>
                      </div>
                    </td>
                    <td>
                      <p v-if="!isMobile">{{ item.syamei }}</p>
                      <div v-else class="row">
                        <p class="col-4 bold blue">車名</p>
                        <p class="col-8 pl-0">{{ item.syamei }}</p>
                      </div>
                    </td>
                    <td>
                      <p v-if="!isMobile">{{ item.hikitorisaki }}</p>
                      <div v-else class="row">
                        <p class="col-4 bold blue">引取先</p>
                        <p class="col-8 pl-0">{{ item.hikitorisaki }}</p>
                      </div>
                    </td>
                    <td>
                      <p v-if="!isMobile">{{ item.hikitoriyoteibi }}</p>
                      <div v-else class="row">
                        <p class="col-4 bold blue">
                          引取
                          <br />
                          予定日
                        </p>
                        <p class="col-8 pl-0">{{ item.hikitoriyoteibi }}</p>
                      </div>
                    </td>
                    <td>
                      <p v-if="!isMobile">{{ item.hikitorikanryobi }}</p>
                      <div v-else class="row">
                        <p class="col-4 bold blue">
                          引取
                          <br />
                          完了日
                        </p>
                        <p class="col-8 pl-0">{{ item.hikitorikanryobi }}</p>
                      </div>
                    </td>
                    <td>
                      <div
                        v-if="
                          !Number(
                            $store.state.user.data.hum_torihiki.NAVI_RYOKIN_FLG
                          )
                        "
                      >
                        <div class="text-right">
                          <b-button
                            class="btn-success ml-3 break-down-btn"
                            @click="getUchiwake(item.id, item.gassanryokin)"
                          >
                            内訳
                          </b-button>
                        </div>
                        <p v-if="!isMobile">
                          {{
                            item.gassanryokin
                              ? separateComma(item.gassanryokin)
                              : 0
                          }}
                          円
                        </p>
                        <div v-else class="row">
                          <p class="col-4 bold blue">合算料金</p>
                          <p class="col-8 pl-0">
                            {{
                              item.gassanryokin
                                ? separateComma(item.gassanryokin)
                                : 0
                            }}
                            円
                          </p>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr id="second" :class="{ 'bg-odd': index % 2 && !isMobile }">
                    <td>
                      <p v-if="!isMobile">{{ item.logicobango }}</p>
                      <div v-else class="row">
                        <p class="col-4 bold blue">
                          ロジコ
                          <br />
                          管理番号
                        </p>
                        <p class="col-8 pl-0">{{ item.logicobango }}</p>
                      </div>
                    </td>
                    <td>
                      <p v-if="!isMobile">{{ item.status }}</p>
                      <div v-else class="row">
                        <p class="col-4 bold blue">ステータス</p>
                        <p class="col-8 pl-0">{{ item.status }}</p>
                      </div>
                    </td>
                    <td>
                      <p v-if="!isMobile" v-html="getBango(item)" />
                      <div v-else class="row">
                        <p class="col-4 bold blue">
                          車台番号/
                          <br />
                          登録番号
                        </p>
                        <p class="col-8 pl-0" v-html="getBango(item)" />
                      </div>
                    </td>
                    <td>
                      <p v-if="!isMobile">{{ item.nosysasaki }}</p>
                      <div v-else class="row">
                        <p class="col-4 bold blue">納車先</p>
                        <p class="col-8 pl-0">{{ item.nosysasaki }}</p>
                      </div>
                    </td>
                    <td>
                      <p v-if="!isMobile">{{ item.nosyayoteibi }}</p>
                      <div v-else class="row">
                        <p class="col-4 bold blue">
                          納車
                          <br />
                          予定日
                        </p>
                        <p class="col-8 pl-0">{{ item.nosyayoteibi }}</p>
                      </div>
                    </td>
                    <td>
                      <p v-if="!isMobile">{{ item.nosyakanryobi }}</p>
                      <div v-else class="row">
                        <p class="col-4 bold blue">
                          納車
                          <br />
                          完了日
                        </p>
                        <p class="col-8 pl-0">{{ item.nosyakanryobi }}</p>
                      </div>
                    </td>
                    <td>
                      <p v-if="!isMobile" class="text-center">
                        <font-awesome-icon
                          icon="camera"
                          class="camera-icon"
                          v-if="getNaviImgFlg('NAVI_IMG_FLG', item)"
                          @click="getCarPhotos(item)"
                        />
                      </p>
                      <div v-else class="row">
                        <p class="col-4 bold blue">画像</p>
                        <p class="col-8 pl-0">
                          <font-awesome-icon
                            v-if="getNaviImgFlg('NAVI_IMG_FLG', item)"
                            icon="camera"
                            class="camera-icon"
                            @click="getCarPhotos(item)"
                          />
                        </p>
                      </div>
                    </td>
                  </tr>
                  <tr id="last" :class="{ 'bg-odd': index % 2 && !isMobile }">
                    <td colspan="4">
                      <div class="row">
                        <div
                          :class="[
                            'col-6',
                            {
                              'pr-0':
                                Number(item.meihen) === 1 ||
                                item.irekae_child_syamei,
                            },
                          ]"
                        >
                          <span v-if="groups.length">
                            企業名：
                            <br v-if="isMobile" />
                            {{ item.sofusaki }}
                            <br />
                          </span>
                          <span>
                            発注者：
                            <br v-if="isMobile" />
                            {{ item.hachusya }}
                          </span>
                        </div>
                        <div class="col-6 pl-0">
                          <span
                            v-if="Number(item.meihen) === 1"
                            class="meihen-icon"
                          >
                            <font-awesome-icon
                              icon="truck"
                              style="margin: 0 4px"
                            />
                            名変輸送
                          </span>
                          <div v-else-if="item.irekae_child_syamei">
                            下取/入替車：
                            <br v-if="isMobile" />
                            <b-link @click="gotoDetail(item.irekae_id)">
                              {{ item.irekae_child_syamei }}
                            </b-link>
                          </div>
                          <div v-else-if="item.irekae_parent_syamei">
                            <div class="irekae-icon">
                              <font-awesome-icon icon="sync" />
                              入替車
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td colspan="3" class="text-right">
                      <b-button
                        class="b-btn btn-success sp-fs-14"
                        @click="gotoDetail(item.id)"
                      >
                        詳細
                      </b-button>
                      <b-button
                        class="btn-primary sp-fs-14"
                        v-if="displayBtn(item)"
                        @click="handleEditBtn(item)"
                      >
                        編集
                      </b-button>
                      <b-button
                        class="btn-secondary sp-fs-14"
                        v-if="displayBtn(item)"
                        @click="handleCancelBtn(item)"
                      >
                        キャンセル
                      </b-button>
                      <b-button
                        class="btn-secondary sp-fs-14"
                        v-else-if="item.status_flg == 9"
                        disabled
                      >
                        キャンセル済み
                      </b-button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-tab>

            <!-- 全て -->
            <b-tab
              title="すべて"
              :active="!isTabRecent"
              @click="changeTab('all')"
            >
              <table class="table">
                <thead>
                  <tr>
                    <th>貴社管理番号</th>
                    <th>注文日</th>
                    <th>車名</th>
                    <th>引取先</th>
                    <th>引取予定日</th>
                    <th>引取完了日</th>
                    <th>合算料金</th>
                  </tr>
                  <tr>
                    <th>ロジコ管理番号</th>
                    <th>ステータス</th>
                    <th>車台番号(登録番号)</th>
                    <th>納車先</th>
                    <th>納車予定日</th>
                    <th>納車完了日</th>
                    <th>画像</th>
                  </tr>
                </thead>
                <tbody v-for="(item, index) in getItems" :key="item.id">
                  <tr :class="{ 'bg-odd': index % 2 && !isMobile }">
                    <td :class="{ 'bg-blue white': isMobile }">
                      <div class="text-right">
                        <button
                          type="button"
                          class="btn-lg btn-success md-raised pen-btn"
                          @click="editKisyaKnariBango(item)"
                        >
                          <font-awesome-icon
                            icon="pen-fancy"
                            class="pen-icon"
                          />
                        </button>
                      </div>
                      <p v-if="!isMobile">{{ item.kanribango }}</p>
                      <div v-else class="row">
                        <p class="col-4 bold">
                          貴社
                          <br />
                          管理番号
                        </p>
                        <p class="col-8 pl-0">{{ item.kanribango }}</p>
                      </div>
                    </td>
                    <td>
                      <p v-if="!isMobile">{{ item.chumonbi }}</p>
                      <div v-else class="row">
                        <p class="col-4 bold blue">注文日</p>
                        <p class="col-8 pl-0">{{ item.chumonbi }}</p>
                      </div>
                    </td>
                    <td>
                      <p v-if="!isMobile">{{ item.syamei }}</p>
                      <div v-else class="row">
                        <p class="col-4 bold blue">車名</p>
                        <p class="col-8 pl-0">{{ item.syamei }}</p>
                      </div>
                    </td>
                    <td>
                      <p v-if="!isMobile">{{ item.hikitorisaki }}</p>
                      <div v-else class="row">
                        <p class="col-4 bold blue">引取先</p>
                        <p class="col-8 pl-0">{{ item.hikitorisaki }}</p>
                      </div>
                    </td>
                    <td>
                      <p v-if="!isMobile">{{ item.hikitoriyoteibi }}</p>
                      <div v-else class="row">
                        <p class="col-4 bold blue">
                          引取
                          <br />
                          予定日
                        </p>
                        <p class="col-8 pl-0">{{ item.hikitoriyoteibi }}</p>
                      </div>
                    </td>
                    <td>
                      <p v-if="!isMobile">{{ item.hikitorikanryobi }}</p>
                      <div v-else class="row">
                        <p class="col-4 bold blue">
                          引取
                          <br />
                          完了日
                        </p>
                        <p class="col-8 pl-0">{{ item.hikitorikanryobi }}</p>
                      </div>
                    </td>
                    <td>
                      <div
                        v-if="
                          !Number(
                            $store.state.user.data.hum_torihiki.NAVI_RYOKIN_FLG
                          )
                        "
                      >
                        <div class="text-right">
                          <b-button
                            class="btn-success ml-3 break-down-btn"
                            @click="getUchiwake(item.id, item.gassanryokin)"
                          >
                            内訳
                          </b-button>
                        </div>
                        <p v-if="!isMobile">
                          {{
                            item.gassanryokin
                              ? separateComma(item.gassanryokin)
                              : 0
                          }}
                          円
                        </p>
                        <div v-else class="row">
                          <p class="col-4 bold blue">合算料金</p>
                          <p class="col-8 pl-0">
                            {{
                              item.gassanryokin
                                ? separateComma(item.gassanryokin)
                                : 0
                            }}
                            円
                          </p>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr :class="{ 'bg-odd': index % 2 && !isMobile }">
                    <td>
                      <p v-if="!isMobile">{{ item.logicobango }}</p>
                      <div v-else class="row">
                        <p class="col-4 bold blue">
                          ロジコ
                          <br />
                          管理番号
                        </p>
                        <p class="col-8 pl-0">{{ item.logicobango }}</p>
                      </div>
                    </td>
                    <td>
                      <p v-if="!isMobile">{{ item.status }}</p>
                      <div v-else class="row">
                        <p class="col-4 bold blue">ステータス</p>
                        <p class="col-8 pl-0">{{ item.status }}</p>
                      </div>
                    </td>
                    <td>
                      <p v-if="!isMobile" v-html="getBango(item)" />
                      <div v-else class="row">
                        <p class="col-4 bold blue">
                          車台番号/
                          <br />
                          登録番号
                        </p>
                        <p class="col-8 pl-0" v-html="getBango(item)" />
                      </div>
                    </td>
                    <td>
                      <p v-if="!isMobile">{{ item.nosysasaki }}</p>
                      <div v-else class="row">
                        <p class="col-4 bold blue">納車先</p>
                        <p class="col-8 pl-0">{{ item.nosysasaki }}</p>
                      </div>
                    </td>
                    <td>
                      <p v-if="!isMobile">{{ item.nosyayoteibi }}</p>
                      <div v-else class="row">
                        <p class="col-4 bold blue">
                          納車
                          <br />
                          予定日
                        </p>
                        <p class="col-8 pl-0">{{ item.nosyayoteibi }}</p>
                      </div>
                    </td>
                    <td>
                      <p v-if="!isMobile">{{ item.nosyakanryobi }}</p>
                      <div v-else class="row">
                        <p class="col-4 bold blue">
                          納車
                          <br />
                          完了日
                        </p>
                        <p class="col-8 pl-0">{{ item.nosyakanryobi }}</p>
                      </div>
                    </td>
                    <td>
                      <p v-if="!isMobile" class="text-center">
                        <font-awesome-icon
                          icon="camera"
                          class="camera-icon"
                          v-if="getNaviImgFlg('NAVI_IMG_FLG', item)"
                          @click="getCarPhotos(item)"
                        />
                      </p>
                      <div v-else class="row">
                        <p class="col-4 bold blue">画像</p>
                        <p class="col-8 pl-0">
                          <font-awesome-icon
                            v-if="getNaviImgFlg('NAVI_IMG_FLG', item)"
                            icon="camera"
                            class="camera-icon"
                            @click="getCarPhotos(item)"
                          />
                        </p>
                      </div>
                    </td>
                  </tr>
                  <tr id="last" :class="{ 'bg-odd': index % 2 && !isMobile }">
                    <td colspan="4">
                      <div class="row">
                        <div
                          :class="[
                            'col-6',
                            {
                              'pr-0':
                                Number(item.meihen) === 1 ||
                                item.irekae_child_syamei,
                            },
                          ]"
                        >
                          <span v-if="groups.length">
                            企業名：
                            <br v-if="isMobile" />
                            {{ item.sofusaki }}
                            <br />
                          </span>
                          <span>
                            発注者：
                            <br v-if="isMobile" />
                            {{ item.hachusya }}
                          </span>
                        </div>
                        <div class="col-6 pl-0">
                          <span
                            v-if="Number(item.meihen) === 1"
                            class="meihen-icon"
                          >
                            <font-awesome-icon
                              icon="truck"
                              style="margin: 0 4px"
                            />
                            名変輸送
                          </span>
                          <div v-else-if="item.irekae_child_syamei">
                            下取/入替車：
                            <br v-if="isMobile" />
                            <b-link @click="gotoDetail(item.irekae_id)">
                              {{ item.irekae_child_syamei }}
                            </b-link>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td colspan="3" class="text-right">
                      <b-button
                        class="b-btn btn-success sp-fs-14"
                        @click="gotoDetail(item.id)"
                      >
                        詳細
                      </b-button>
                      <b-button
                        class="btn-primary sp-fs-14"
                        v-if="displayBtn(item)"
                        @click="handleEditBtn(item)"
                      >
                        編集
                      </b-button>
                      <b-button
                        class="btn-secondary sp-fs-14"
                        v-if="displayBtn(item)"
                        @click="handleCancelBtn(item)"
                      >
                        キャンセル
                      </b-button>
                      <b-button
                        class="btn-secondary sp-fs-14"
                        v-else-if="item.status_flg == 9"
                        disabled
                      >
                        キャンセル済み
                      </b-button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-tab>
          </b-tabs>

          <paginate
            ref="paginate2"
            class="mt-3"
            :page-count="getPageCount"
            :page-range="3"
            :margin-pages="2"
            :click-handler="changePage"
            :prev-text="'＜'"
            :next-text="'＞'"
            :container-class="'pagination'"
            :page-class="'page-item'"
            :page-link-class="'page-link'"
            :prev-class="'page-item'"
            :prev-link-class="'page-link'"
            :next-class="'page-item'"
            :next-link-class="'page-link'"
          />
        </div>
      </section>
    </div>

    <!-- モーダル -->
    <md-dialog
      :md-active.sync="showBreakDownDialog"
      class="new w-600"
      :md-fullscreen="false"
      @md-opened="scroll('locked')"
      @md-closed="scroll('clear')"
    >
      <md-dialog-title>料金内訳</md-dialog-title>
      <div class="py-2 px-4">
        <label class="col-md-4 mt-3 px-0"><strong>通常</strong></label>
        <div>
          <div class="row" v-for="u in uchiwakeDetail.normal" :key="u.id">
            <label class="col-8">{{ u.NAME }}</label>
            <span class="col-4">{{ separateComma(u.RYOKIN) }} 円</span>
          </div>
        </div>
        <label class="col-md-4 mt-3 px-0"><strong>オプション</strong></label>
        <div>
          <div class="row" v-for="u in uchiwakeDetail.option" :key="u.id">
            <label class="col-8">{{ u.NAME }}</label>
            <span class="col-4">{{ separateComma(u.RYOKIN) }} 円</span>
          </div>
        </div>
        <div class="mt-5">
          <div class="row">
            <label class="col-8"><strong>合計</strong></label>
            <span class="col-4">
              {{
                uchiwakeDetail.gassanryokin
                  ? separateComma(uchiwakeDetail.gassanryokin)
                  : 0
              }}
              円
            </span>
          </div>
        </div>
      </div>
      <div>
        <md-dialog-actions>
          <md-button class="md-primary" @click="showBreakDownDialog = false">
            閉じる
          </md-button>
        </md-dialog-actions>
      </div>
    </md-dialog>

    <!-- 画像一覧モーダル -->
    <md-dialog
      id="image-list-modal"
      :md-active.sync="showImageDialog"
      class="new w-800"
      :md-fullscreen="false"
      @md-opened="scroll('locked')"
      @md-closed="scroll('clear')"
    >
      <md-dialog-title>画像一覧</md-dialog-title>
      <div class="text-right" style="overflow: unset">
        <md-button class="md-primary" @click="showImageDialog = false">
          閉じる
        </md-button>
      </div>
      <div class="p-2 p-md-4 of-auto">
        <div v-if="selectedImgSyaryo" class="row mb-2 mx-auto">
          <div class="row col-md-4">
            <label class="">管理番号：</label>
            <span>{{ selectedImgSyaryo.kanribango || '' }}</span>
          </div>
          <div class="row col-md-7">
            <label class="">車種名：</label>
            <span>{{ selectedImgSyaryo.syamei || '' }}</span>
          </div>
        </div>
        <div>
          <b-tabs>
            <b-tab
              v-for="tab in photoDetail.photos"
              v-if="displayTab(tab.TITLES)"
              :key="tab.id"
              :title="tab.NAME"
              @click="checkedInTabImgFlg = false"
            >
              <div class="text-right mx-2 mt-2">
                <b-button
                  class="d-inline btn btn-info sp-fs-14"
                  @click="
                    checkedInTabImgFlg
                      ? uncheckedInTabImg(tab)
                      : checkedInTabImg(tab)
                  "
                >
                  一括選択
                </b-button>
                <b-button
                  class="d-inline btn btn-success sp-fs-14"
                  @click="checkedImgDL(tab)"
                  :disabled="!filterInTabImg(tab).length"
                >
                  選択画像をDL
                </b-button>
              </div>
              <div v-for="p in tab.TITLES" v-if="p.PHOTO" :key="p.id">
                <h5 class="page-sub-title pl-2 pl-md-4 mt-2 mb-1">
                  {{ p.NAME }}
                </h5>
                <div
                  v-for="ph in p.PHOTO"
                  :key="ph.id"
                  class="img-box d-inline mx-1"
                >
                  <img
                    :src="ph.GAZO_URL"
                    class="img"
                    @click="
                      setModalImages(photoDetail.syaryo.id, tab.CAT, p.DIV)
                    "
                  />
                  <input type="checkbox" :value="ph" v-model="checkedImgList" />
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </md-dialog>

    <!-- 画像詳細モーダル -->
    <md-dialog
      id="image-detail-modal"
      :md-active.sync="showImageDetailDialog"
      class="new w-800 h-700"
    >
      <md-dialog-title>画像</md-dialog-title>
      <div class="text-right mr-4">
        <b-button class="btn-success sp-fs-14" @click="print()">印刷</b-button>
        <md-button class="md-primary" @click="showImageDetailDialog = false">
          閉じる
        </md-button>
      </div>
      <h5 class="_page-sub-title pl-2 pl-md-4 w-90">{{ popupTitle }}</h5>
      <div class="px-auto img-wrapper">
        <div :class="{ 'mb-3': popupData.length === 1 }">
          <b-carousel
            id="carousel-1"
            v-model="slide"
            :interval="0"
            controls
            indicators
            background="#ababab"
            style="text-shadow: 1px 1px 2px #333"
            @sliding-start="onSlideStart"
            @sliding-end="onSlideEnd"
          >
            <!-- Text slides with image -->
            <b-carousel-slide
              v-for="img in popupData"
              :key="img.id"
              :img-src="img.GAZO_URL"
            />
          </b-carousel>
        </div>
      </div>
    </md-dialog>

    <!-- 貴社管理番号編集 -->
    <md-dialog-prompt
      class="new"
      :md-fullscreen="false"
      :md-active.sync="showEditKanriBangoDialog"
      v-model="editItem.kanribango"
      md-title="貴社管理番号"
      md-input-maxlength="20"
      md-input-placeholder=""
      @md-confirm="saveItem()"
      md-cancel-text="閉じる"
      md-confirm-text="更新"
    />

    <md-dialog-confirm
      class="new pink"
      :md-fullscreen="false"
      :md-active.sync="isErrDialog"
      md-title=""
      :md-content="errMessage"
      md-confirm-text="問い合わせる"
      md-cancel-text="キャンセル"
      :md-click-outside-to-close="false"
      @md-confirm="gotoInquiry"
    />

    <md-dialog-confirm
      class="new pink"
      :md-fullscreen="false"
      @md-opened="scroll('locked')"
      @md-closed="scroll('clear')"
      :md-active.sync="isYoshiFukaModal"
      md-title=""
      :md-content="getHcbApiErrorMessage('untrustEdit')"
      md-confirm-text="問い合わせる"
      md-cancel-text="キャンセル"
      :md-click-outside-to-close="true"
      @md-confirm="gotoInquiry"
    />

    <!-- 発注編集確認 -->
    <md-dialog-confirm
      class="new"
      :md-fullscreen="false"
      @md-opened="scroll('locked')"
      @md-closed="scroll('clear')"
      :md-active.sync="isEditConfirm"
      md-title=""
      md-content="<strong>対象車両の発注を編集しますか？</strong>"
      md-confirm-text="はい"
      md-cancel-text="いいえ"
      @md-confirm="orderEdit"
    />

    <!-- 発注キャンセル確認 -->
    <md-dialog-confirm
      class="new"
      :md-fullscreen="false"
      @md-opened="scroll('locked')"
      @md-closed="scroll('clear')"
      :md-active.sync="isCancelConfirm"
      md-title=""
      md-content="<strong>対象車両の発注をキャンセルしてもよろしいですか？</strong>"
      md-confirm-text="はい"
      md-cancel-text="いいえ"
      @md-confirm="orderCancel"
    />
    <md-dialog-alert
      class="new"
      :md-fullscreen="false"
      @md-opened="scroll('locked')"
      @md-closed="scroll('clear')"
      :md-active.sync="isCanceled"
      md-content="<strong>発注をキャンセルしました。</strong>"
    />
    <inquiry-dialog
      :jyuchu-syaryo-id="inquiry.jyuchuSyaryoId"
      :is-showing-inquiry-dialog-confirm.sync="inquiry.isShowing"
      :hikitori-yotei-bi="inquiry.hikitoriYoteiBi"
    />
  </div>
</template>

<script>
import orderApi from '@/api/order'
import InquiryDialog from '@/components/order/InquiryDialog'
import Accordion from '@/components/utils/Accordion'
import Constant from '@/const'
import {saveAs} from 'file-saver'
import iconv from 'iconv-lite'
import Jszip from 'jszip'
import {Carousel, Slide} from 'vue-carousel'
import Mixin from '../mixin/Mixin'

export default {
  name: 'Index',
  components: {
    Carousel,
    Slide,
    Accordion,
    InquiryDialog,
  },
  mixins: [Mixin],
  data: () => ({
    errMessage: '',
    selectedItem: null,
    nowSlide: 0,
    isErrDialog: false,
    showBreakDownDialog: false,
    showImageDialog: false,
    showImageDetailDialog: false,
    showEditKanriBangoDialog: false,
    isEditConfirm: false,
    isCancelConfirm: false,
    isCanceled: false,
    carSmapleImg: require('../../assets/img/car-sample.jpg'),
    uchiwakeDetail: [],
    photoDetail: [],
    popupData: [],
    popupTitle: '',
    transports_recent: [],
    transports: [],
    status: Constant.ORDER.STATUS,
    sortKey: 'chumonbi_desc',
    sortList: [
      { key: 'kanribango_asc', name: '貴社管理番号▲' },
      { key: 'kanribango_desc', name: '貴社管理番号▼' },
      { key: 'logicobango_asc', name: 'ロジコ管理番号▲' },
      { key: 'logicobango_desc', name: 'ロジコ管理番号▼' },
      { key: 'status_asc', name: 'ステータス▲' },
      { key: 'status_desc', name: 'ステータス▼' },
      { key: 'syamei_asc', name: '車名▲' },
      { key: 'syamei_desc', name: '車名▼' },
      { key: 'syadaibango_asc', name: '車台番号▲' },
      { key: 'syadaibango_desc', name: '車台番号▼' },
      { key: 'hikitorisaki_asc', name: '引取先▲' },
      { key: 'hikitorisaki_desc', name: '引取先▼' },
      { key: 'nosysasaki_asc', name: '納車先▲' },
      { key: 'nosysasaki_desc', name: '納車先▼' },
      { key: 'hikitoriyotei_asc', name: '引取予定日▲' },
      { key: 'hikitoriyoteibi_desc', name: '引取予定日▼' },
      { key: 'nosyayoteibi_asc', name: '納車予定日▲' },
      { key: 'nosyayoteibi_desc', name: '納車予定日▼' },
      { key: 'chumonbi_asc', name: 'ご注文日▲' },
      { key: 'chumonbi_desc', name: 'ご注文日▼' },
      { key: 'gassanryokin_asc', name: '料金▲' },
      { key: 'gassanryokin_desc', name: '料金▼' },
    ],
    editItem: {},
    parPage: null,
    currentPage: 1,
    recentCurrentPage: 1,
    activeTabName: 'recent',
    total: 0,
    recentTotal: 0,
    groups: [],
    /** チェックをつけた画像リスト **/
    checkedImgList: [],
    /** 表示した画像の車両データ **/
    selectedImgSyaryo: null,
    /** 画像一括チェックフラグ **/
    checkedInTabImgFlg: false,
    /** 与信不可モーダル表示フラグ **/
    isYoshiFukaModal: false,

    slide: 0,
    sliding: null,

    inquiry: {
      jyuchuSyaryoId: null,
      hikitoriYoteiBi: null,
      isShowing: false,
    },
  }),
  async mounted() {
    this.spinerOn()
    await this.setGroupList()
    if (this.getPaginateParams()) {
      this.setPaginateData()
      await this.setStateHistory()
      this.changeTab(this.getPaginateParams().activeTabName)
    } else {
      this.setStateHistory()
    }
  },
  methods: {
    onSlideStart(slide) {
      this.sliding = true
    },

    onSlideEnd(slide) {
      this.sliding = false
    },

    gotoDetail(id) {
      this.$router.push({
        name: 'HistoryDetail',
        params: { id, paginate: this.makePaginateParams() },
      })
    },
    setPaginateData() {
      this.sortKey = this.getPaginateParams().sortKey
      this.currentPage = this.getPaginateParams().currentPage
      this.recentCurrentPage = this.getPaginateParams().recentCurrentPage
    },
    getPaginateParams() {
      return this.$route.params.paginate
    },
    makePaginateParams() {
      return {
        activeTabName: this.activeTabName,
        currentPage: this.currentPage,
        recentCurrentPage: this.recentCurrentPage,
        sortKey: this.sortKey,
      }
    },
    changePage(pageNum, isSearch = true) {
      if (this.isTabRecent) this.recentCurrentPage = pageNum
      else this.currentPage = pageNum
      if (this.$refs.paginate1) this.$refs.paginate1.selected = Number(pageNum)
      if (this.$refs.paginate2) this.$refs.paginate2.selected = Number(pageNum)
      if (isSearch) this.search(this.activeTabName)
    },
    getBango(item) {
      let bango = item.syadaibango || ''
      if (item.tourokubango) {
        bango += bango ? `<br>(${item.tourokubango})` : item.tourokubango
      }
      return bango
    },
    async setStateHistory() {
      let searchConds = this.$route.params.search_conds
      if (this.$route.query.kanrino) {
        if (searchConds === undefined)
          searchConds = { LOGICO_MNG_NO: this.$route.query.kanrino }
        else searchConds['LOGICO_MNG_NO'] = this.$route.query.kanrino
        this.activeTabName = 'all'
      }
      if (searchConds) {
        for (const stateName in searchConds) {
          this.$store.state.history[stateName] = searchConds[stateName]
        }
      }

      await this.search()

      // 詳細検索ブロックの表示判定
      let stateHistory = this.$store.state.history
      if (
        stateHistory.TOUROKU_NO ||
        stateHistory.HIKITORI_SAKI ||
        stateHistory.NOUHIN_SAKI ||
        stateHistory.LOGICO_MNG_NO ||
        stateHistory.ORDER_DATE_FROM ||
        stateHistory.ORDER_DATE_TO ||
        stateHistory.HIKITORI_YOTEI_DATE_FROM ||
        stateHistory.HIKITORI_YOTEI_DATE_TO ||
        stateHistory.NOUSYA_YOTEI_DATE_FROM ||
        stateHistory.NOUSYA_YOTEI_DATE_TO ||
        (stateHistory.YUSOU_SYUBETSU && stateHistory.YUSOU_SYUBETSU.length) ||
        (stateHistory.STATUS && stateHistory.STATUS.length)
      ) {
        this.$refs.search_accordion.setDisplay(true)
      } else {
        this.$refs.search_accordion.setDisplay(false)
      }
    },
    getNaviImgFlg(imgFlg, item) {
      if (!item.gazo_count) return false
      // 全体画像フラグが1でなければ全画像非表示（＝カメラアイコン非表示）
      if (this.torihiki.NAVI_IMG_FLG < 1) {
        return false
      } else {
        if (this.torihiki[imgFlg] > 0) {
          return true
        }
        return false
      }
    },
    setSlide(p) {
      this.nowSlide = p
    },
    print() {
      window.open(this.popupData[this.nowSlide].GAZO_URL)
    },
    setItem(item) {
      this.selectedItem = item
    },
    orderEdit() {
      this.spinerOn()
      this.$store
        .dispatch('order/getJyucyuFromId', { ID: this.selectedItem.id })
        .then((res) => {
          const params = {
            data: res.data,
            yusoKbn: Number(res.data.navi_jyuchu.MEIHEN_FLG),
            isFromHistoryEdit: true,
          }
          this.$router.push({
            name: Number(res.data.navi_jyuchu.MEIHEN_FLG)
              ? 'OrderMeihenTransport'
              : 'OrderTransport',
            params,
          })
          this.spinerOff()
          this.scroll('clear')
        })
        .catch((err) => {
          this.errMessage = err.message
          this._alert(this.errMessage, false)
          this.spinerOff()
          this.scroll('clear')
        })
    },
    orderCancel() {
      this.spinerOn()
      this.$store
        .dispatch('history/cancelJyucyuSyaryo', this.selectedItem)
        .then((res) => {
          this.selectedItem.status_flg = 9
          this.selectedItem.status = 'キャンセル'
          this.spinerOff()
          this.scroll('clear')
          this.isCanceled = true
        })
        .catch((err) => {
          this.errMessage = this.getHcbApiErrorMessage(err.message)
          this.isErrDialog = true
          this.spinerOff()
          this.scroll('clear')
        })
    },
    resetForm() {
      const shikiCd = this.getShikiCd
      this.$store.commit('history/destroy')
      this.$store.state.history.JYUCYU_SHIKI_CD = shikiCd
    },
    forcePageFirst() {
      this.recentCurrentPage = 1
      this.currentPage = 1
      if (this.$refs.paginate1) this.$refs.paginate1.selected = 1
      if (this.$refs.paginate2) this.$refs.paginate2.selected = 1
    },
    getHistoryData(page = null, isRecent = false) {
      return this.$store.dispatch(
        'history/search',
        Object.assign(
          {
            page,
            isRecent,
            sortKey: this.sortKey,
          },
          this.$store.state.history
        )
      )
    },
    convertData(val) {
      var d = {}
      d.id = val.syaryo_ID
      d.jyuchuid = val.syaryo_NAVI_JYUCHU_ID
      d.kanribango = val.syaryo_KISYA_KANRI_BANGO
      d.chumonbi = this.dateFormat(val.syaryo_JYUCHU_BI)
      d.chumonbifull = val.syaryo_JYUCHU_BI
      d.syamei = val.syaryo_SYARYO_MEI
      d.hikitorisaki = val.jyucyu_HIKITORI_MEI
      d.hikitoriyoteibi =
        val.syaryo_SYARYO_STATUS > 1
          ? this.dateFormat(val.syaryo_HIKITORI_YOTEI_BI)
          : null
      d.logicobango = val.syaryo_KANRI_BANGO
      d.status_flg = val.syaryo_SYARYO_STATUS
      d.status = this.convStatus(val.syaryo_SYARYO_STATUS)
      d.syadaibango = val.syaryo_SYADAI_BANGO
      d.nosysasaki = val.jyucyu_NOSYA_MEI
      d.nosyayoteibi =
        val.syaryo_SYARYO_STATUS > 1
          ? this.dateFormat(val.syaryo_NOSYA_YOTEI_BI)
          : null
      d.hachusya = val.jyucyu_HUM_TANTO_MEI
      d.meihen = val.jyucyu_MEIHEN_FLG
      d.gassanryokin = val.uchiwake_RYOKIN_SUM
      d.iraiid = val.syaryo_IRAI_JYUCHU_ID
      d.tourokubango = val.syaryo_TOUROKU_BANGO
        ? val.syaryo_TOUROKU_BANGO.replace(/ /g, '-')
        : ''
      d.syuppinbango = val.jyucyu_HIKITORI_AA_POS_BANGO
      d.nagasa = val.syaryo_SYARYO_NAGASA
      d.haba = val.syaryo_SYARYO_HABA
      d.takasa = val.syaryo_SYARYO_TAKASA
      d.type = val.syaryo_SYARYO_TYPE_KBN
      d.numberplateflg = val.syaryo_NUMBER_PLATE_FLG
      d.syaryobiko = val.syaryo_BIKO
      d.gazo_count = val.gazo_COUNT
      d.sofusaki = val.jyucyu_SOFU_SAKI_MEI
      d.shikicd = val.syaryo_JYUCYU_SHIKI_CD

      // 入替車設定
      d.irekae_parent_syamei = null
      d.irekae_child_syamei = val.syaryo_CHILD_IREKAE_SYARYO_MEI
      if (!d.irekae_child_syamei) {
        d.irekae_parent_syamei = val.syaryo_PARENT_IREKAE_SYARYO_MEI
      }
      d.irekae_id = val.syaryo_IREKAE_SYARYO_ID
      if (!d.irekae_id) d.irekae_id = val.syaryo_CHILD_IREKAE_SYARYO_ID

      let hikitoriKanryobi = ''
      let nosyaKanryobi = ''
      if (val.syaryo_SYARYO_STATUS > 1) {
        hikitoriKanryobi = Number(this.torihiki.NAVI_JISSEKIBI_FLG)
          ? this.dateFormat(val.syaryo_HIKITORI_KANRYO_BI)
          : '-----'
      }
      if (val.syaryo_SYARYO_STATUS > 1) {
        nosyaKanryobi = Number(this.torihiki.NAVI_JISSEKIBI_FLG)
          ? this.dateFormat(val.syaryo_NOSYA_KANRYO_BI)
          : '-----'
      }
      d.hikitorikanryobi = hikitoriKanryobi
      d.nosyakanryobi = nosyaKanryobi
      return d
    },
    /**
     * 検索実行
     * @param string tab 検索するタブ名
     */
    async search(tab = null) {
      this.$scrollTo('#dl-btn')
      this.spinerOn()
      const _this = this

      const makeList = function (page, isRecent = false) {
        return _this.getHistoryData(page, isRecent).then((res) => {
          var rows = []
          for (var i = 0; i < res.data.data.length; i++) {
            rows.push(_this.convertData(res.data.data[i]))
          }
          return { rows, total: res.data.total.total, limit: res.data.limit }
        })
      }

      /**
       * 直近データ取得
       */
      const latest = () => {
        const isRecent = true
        return makeList(_this.recentCurrentPage, isRecent).then((res) => {
          _this.parPage = res.limit
          _this.transports_recent = res.rows
          _this.recentTotal = res.total
        })
      }

      /**
       * 全データ取得
       */
      const all = () => {
        return makeList(_this.currentPage).then((res) => {
          _this.transports = res.rows
          _this.total = res.total
        })
      }

      let func = []
      switch (tab) {
        case 'recent':
          func.push(latest())
          break
        case 'all':
          func.push(all())
          break
        default:
          func.push(latest())
          func.push(all())
      }

      await Promise.all(func).catch((err) => {
        this.consents = []
        this.errMessage = err.message
        this.isErrMessage = true
        this._alert(_this.errMessage)
      })
      this.spinerOff()
      this.scroll('clear')
    },
    getUchiwake(syaryoId) {
      this.spinerOn()
      this.$store
        .dispatch('history/uchiwake', {
          syaryo_id: syaryoId,
          JYUCYU_SHIKI_CD: this.getShikiCd,
        })
        .then((res) => {
          this.uchiwakeDetail = res.data
          this.spinerOff() // Close spinner.
          this.showBreakDownDialog = true
        })
        .catch((err) => {
          this.errMessage = err.message
          this.isErrMessage = true
          this._alert(this.errMessage) // test
          this.spinerOff() // Close spinner.
          this.scroll('clear')
        })
    },
    getCarPhotos(syaryo) {
      this.spinerOn()
      this.photoDetail = [] // 表示の残存を解消
      this.selectedImgSyaryo = syaryo
      this.$store
        .dispatch('history/photos', {
          syaryo_id: syaryo.id,
          JYUCYU_SHIKI_CD: this.getShikiCd,
        })
        .then((res) => {
          this.photoDetail = res.data
          this.spinerOff()
          this.showImageDialog = true
        })
        .catch((err) => {
          this.errMessage = err.message
          this.isErrMessage = true
          this._alert(this.errMessage) // test
          this.spinerOff() // Close spinner.
          this.scroll('clear')
        })
    },
    setModalImages(syaryoId, cat, div) {
      this.popupTitle = this.photoDetail.photos[cat]['NAME']
      this.popupData = this.photoDetail.photos[cat]['TITLES'][div]['PHOTO']
      this.showImageDetailDialog = true
    },
    async csvDownload() {
      const _this = this
      this.spinerOn()
      await this.getHistoryData()
        .then((res) => {
          if (!res.data.data) throw new Error('対象のデータがありません。')
          let csv = this.groups.length ? '\ufeff企業名,' : '\ufeff'
          csv += `貴社管理番号,ロジコ管理番号,注文日,ステータス,車名,車台番号,登録番号,引取先,引取予定日,納車先,納車予定日,合算料金,発注者,出品番号,長さ,幅,高さ,車両タイプ,車両備考,ナンバー別送サービス\n`
          res.data.data.forEach((r) => {
            r = this.convertData(r)
            let line = [
              r['kanribango'],
              r['logicobango'],
              r['chumonbi'],
              r['status'],
              r['syamei'],
              r['syadaibango'],
              r['tourokubango'],
              r['hikitorisaki'],
              r['hikitoriyoteibi'],
              r['nosysasaki'],
              r['nosyayoteibi'],
              r['gassanryokin'],
              r['hachusya'],
              r['syuppinbango'],
              r['nagasa'],
              r['haba'],
              r['takasa'],
              this.convSyaryoType(r['type']),
              r['syaryobiko'],
              this.convNumberPlateFlg(r['numberplateflg']),
            ]
            if (this.groups.length) line.unshift(r.sofusaki)
            line = line.map(function (elem) {
              return elem !== null && elem !== undefined
                ? `"${_this.csvEscape(elem)}"`
                : ''
            })

            csv += line.join(',') + '\n'
          })

          // bom付きにするとUTF8でもExcelで文字化けしないで開ける
          const bom = new Uint8Array([0xef, 0xbb, 0xbf])
          var blob = new Blob([bom, csv], { type: 'text/csv' })

          const file = 'jisseki.csv'
          if (window.navigator.msSaveBlob) {
            window.navigator.msSaveBlob(blob, file)

            // msSaveOrOpenBlobの場合はファイルを保存せずに開ける
            window.navigator.msSaveOrOpenBlob(blob, file)
          } else {
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = file
            link.click()
          }
        })
        .catch((err) => {
          this._alert(err.message)
        })
      this.spinerOff()
      this.scroll('clear')
    },
    displayBtn(item) {
      return (
        item.shikicd === this.torihiki.JYUCYU_SHIKI_CD &&
        Number(item.status_flg) === 1 &&
        !item.logicobango
      )
    },
    displayTab(titles) {
      let display = false
      for (const key in titles) {
        const title = titles[key]
        if (title.PHOTO) {
          display = true
          break
        }
      }
      return display
    },
    editKisyaKnariBango(item) {
      this.editItem = item
      this.showEditKanriBangoDialog = true
    },
    saveItem() {
      this.spinerOn()
      this.$store
        .dispatch('order/kisyaKanriBango', {
          ID: this.editItem.id,
          KISYA_KANRI_BANGO: this.editItem.kanribango,
          JYUCYU_SHIKI_CD: this.getShikiCd,
        })
        .then((res) => {
          this.spinerOff()
          this.scroll('clear')
        })
        .catch((err) => {
          this.errMessage = err.message
          this._alert(this.errMessage, false)
        })
    },
    changeTab(tabName) {
      this.activeTabName = tabName
      const isSearch = false
      const page = this.isTabRecent ? this.recentCurrentPage : this.currentPage
      this.changePage(page, isSearch)
    },
    // グループ一覧設定
    setGroupList() {
      return this.$store
        .dispatch('group/get')
        .then((res) => {
          if (res.data[0]) this.groups = res.data[0].group_torihiki
        })
        .catch((err) => {
          this._alert(err.message, false)
        })
    },
    /**
     * 指定タブ内の画像全てにチェックをつける
     * @param  Tab tab
     */
    checkedInTabImg(tab) {
      /** チェック済みの画像か判定 **/
      const isChecked = (p) => {
        const list = this.checkedImgList.filter((p2) => p.ID === p2.ID)
        return list.length > 0
      }

      for (let i = 1; i <= 9; i++) {
        if (tab.TITLES[`TITLE${i}`] === undefined) break
        if (!tab.TITLES[`TITLE${i}`].PHOTO) continue
        this.checkedImgList = this.checkedImgList.concat(
          tab.TITLES[`TITLE${i}`].PHOTO.filter((p) => !isChecked(p))
        )
      }
      this.checkedInTabImgFlg = true
    },
    /**
     * 指定タブ内の画像全てのチェックを外す
     * @param  Tab tab
     */
    uncheckedInTabImg(tab) {
      this.checkedImgList = this.filterOutTabImg(tab)
      this.checkedInTabImgFlg = false
    },
    /**
     * チェックした画像のDLを行う
     * @param  Tab tab
     */
    async checkedImgDL(tab) {
      // タイトル毎のファイル名に使うindexを保持
      let titleCount = []

      /** 画像ファイル名を精製 **/
      const makeImgFile = (p) => {
        /** ファイル名のindexを精製 **/
        const index = () => {
          if (titleCount[p.TITLE]) titleCount[p.TITLE]++
          else titleCount[p.TITLE] = 1
          return titleCount[p.TITLE]
        }

        return this.trimProhibitedCharactersInFileName(
          `${p.TITLE}_${index()}.${p['file']['ext']}`
        )
      }

      /** zipファイル名を精製 **/
      const makeZipFile = () => {
        // 管理番号
        let file = this.selectedImgSyaryo.kanribango
          ? `${tab.NAME}_${this.selectedImgSyaryo.kanribango}`
          : `${tab.NAME}`

        // 車名
        file = this.selectedImgSyaryo.syamei
          ? `${file}_${this.selectedImgSyaryo.syamei}`
          : file

        // 車台番号
        file = this.selectedImgSyaryo.syadaibango
          ? `${file}_${this.selectedImgSyaryo.syadaibango}`
          : file
        return this.trimProhibitedCharactersInFileName(`${file}.zip`)
      }

      /** 画像データにタイトル名をマッピングする **/
      const mapTitle = (p) => {
        p.TITLE = tab.TITLES[`TITLE${p.GAZO_TITLE_KBN}`].NAME
        return p
      }

      let zip = new Jszip()
      let photoList = await this.mapBase64Img(this.filterInTabImg(tab))
      for (const p of photoList.map((p) => mapTitle(p))) {
        zip.file(makeImgFile(p), p['file']['base64'], {
          base64: true,
          encodeFileName: (fileName) => iconv.encode(fileName, 'CP932'),
        })
      }
      zip
        .generateAsync({
          type: 'blob',
          encodeFileName: (fileName) => iconv.encode(fileName, 'CP932'),
        })
        .then((blob) => saveAs(blob, makeZipFile()))
    },
    /**
     * 選択タブ内の画像を取得
     * @param  Tab tab
     * @return photo[]
     */
    filterInTabImg(tab) {
      return this.checkedImgList.filter((p) => tab.CAT === `TYPE${p.GAZO_TYPE}`)
    },
    /**
     * 選択タブ外の画像を取得
     * @param  Tab tab
     * @return photo[]
     */
    filterOutTabImg(tab) {
      return this.checkedImgList.filter((p) => tab.CAT !== `TYPE${p.GAZO_TYPE}`)
    },
    /**
     * チェックをつけた画像のbase64画像データをマッピングする
     */
    async mapBase64Img(photoList) {
      this.spinerOn()
      let photos = []
      await this.$store
        .dispatch('photo/getBase64', photoList)
        .then((res) => {
          photos = res.data
        })
        .catch((err) => {
          this.errMessage = err.message
          this._alert(this.errMessage)
        })
      this.scroll('clear')
      this.spinerOff()
      return photos
    },

    async handleCancelBtn(item) {
      this.spinerOn()
      const isUpdatable = await orderApi.getIsUpdatable(item.id)
      this.spinerOff()

      if (isUpdatable) {
        this.setItem(item)
        this.isCancelConfirm = true
        return
      }

      this.inquire(item)
    },

    async handleEditBtn(item) {
      if (this.isYoshinFuka) {
        this.isYoshiFukaModal = true
        return
      }

      this.spinerOn()
      const isUpdatable = await orderApi.getIsUpdatable(item.id)
      this.spinerOff()

      if (isUpdatable) {
        this.setItem(item)
        this.isEditConfirm = true
        return
      }

      this.inquire(item)
    },

    inquire(item) {
      this.inquiry = {
        jyuchuSyaryoId: item.id,
        hikitoriYoteiBi: item.hikitoriyoteibi,
        isShowing: true,
      }
    },
  },
  computed: {
    getItems: function () {
      return this.isTabRecent ? this.transports_recent : this.transports
    },
    getPageCount: function () {
      return this.isTabRecent
        ? Math.ceil(this.recentTotal / this.parPage)
        : Math.ceil(this.total / this.parPage)
    },
    isTabRecent() {
      return this.activeTabName === 'recent'
    },
    getShikiCd() {
      return this.$store.state.history.JYUCYU_SHIKI_CD
    },
    torihiki() {
      return this.$store.state.user.data.hum_torihiki
    },

    /** 受注日From */
    orderDateFrom: {
      get() {
        return this.$store.state.history.ORDER_DATE_FROM
          ? new Date(this.$store.state.history.ORDER_DATE_FROM)
          : null
      },
      set(newVal) {
        this.$store.state.history.ORDER_DATE_FROM = this.dateObjToStr(newVal)
      },
    },

    /** 受注日To */
    orderDateTo: {
      get() {
        return this.$store.state.history.ORDER_DATE_TO
          ? new Date(this.$store.state.history.ORDER_DATE_TO)
          : null
      },
      set(newVal) {
        this.$store.state.history.ORDER_DATE_TO = this.dateObjToStr(newVal)
      },
    },

    /** 引取予定日From */
    hikitoriYoteiDateFrom: {
      get() {
        return this.$store.state.history.HIKITORI_YOTEI_DATE_FROM
          ? new Date(this.$store.state.history.HIKITORI_YOTEI_DATE_FROM)
          : null
      },
      set(newVal) {
        this.$store.state.history.HIKITORI_YOTEI_DATE_FROM =
          this.dateObjToStr(newVal)
      },
    },

    /** 引取予定日To */
    hikitoriYoteiDateTo: {
      get() {
        return this.$store.state.history.HIKITORI_YOTEI_DATE_TO
          ? new Date(this.$store.state.history.HIKITORI_YOTEI_DATE_TO)
          : null
      },
      set(newVal) {
        this.$store.state.history.HIKITORI_YOTEI_DATE_TO =
          this.dateObjToStr(newVal)
      },
    },

    /** 納車予定日From */
    nosyaYoteiDateFrom: {
      get() {
        return this.$store.state.history.NOUSYA_YOTEI_DATE_FROM
          ? new Date(this.$store.state.history.NOUSYA_YOTEI_DATE_FROM)
          : null
      },
      set(newVal) {
        this.$store.state.history.NOUSYA_YOTEI_DATE_FROM =
          this.dateObjToStr(newVal)
      },
    },

    /** 納車予定日To */
    nosyaYoteiDateTo: {
      get() {
        return this.$store.state.history.NOUSYA_YOTEI_DATE_TO
          ? new Date(this.$store.state.history.NOUSYA_YOTEI_DATE_TO)
          : null
      },
      set(newVal) {
        this.$store.state.history.NOUSYA_YOTEI_DATE_TO =
          this.dateObjToStr(newVal)
      },
    },
  },
  watch: {
    /** 画像一覧表示フラグ **/
    showImageDialog(val) {
      if (!val) this.checkedImgList = []
    },
  },
}
</script>

<style lang="sass" scoped>
@import '../../assets/css/logico2'
.accordion
section#history-search
  .vdp-datepicker
    padding: 0
  button
    width: 100px
    height: 30px
.page-title
  margin: 20px 0 40px
.page-sub-title
  padding-bottom: 12px
  margin-top: 12px
  margin-bottom: 12px
  border-bottom: 1px solid #ccc
.bg-odd
  background-color: #fafafa
.fa-times-circle
  margin-right: 4px
  color: #666
  cursor: pointer
.fa-times-circle:hover
  opacity: 0.6
section#history-list
  $borderColor: #dee2e6
  table
    border-collapse: collapse !important
    border: 2px solid $borderColor !important
    tr
      th:nth-child(1)
        width: 13%
      th:nth-child(2)
        width: 10%
      th:nth-child(3)
        width: 19%
      th:nth-child(4)
        width: 19%
      th:nth-child(5)
        width: 12%
      th:nth-child(6)
        width: 11%
      th:nth-child(7)
        width: 16%
      @include sp
        border: 0
        font-size: 14px
        button
          font-size: 14px
        th:nth-child(1)
          width: 17%
        th:nth-child(2)
          width: 10%
        th:nth-child(3)
          width: 17%
        th:nth-child(4)
          width: 17%
        th:nth-child(5)
          width: 12%
        th:nth-child(6)
          width: 11%
        th:nth-child(7)
          width: 16%
    tr#second
      @include sp
        margin-top: -10px
    tr#last
      border: 2px solid $borderColor !important
      @include sp
        border: 0 !important
        margin-top: -10px
    th
      text-align: center
      border-style: dotted
      border-width: 2px
      border-color: $borderColor
      background: $baseBlueColor
      color: white
    td
      border-style: dotted
      border-width: 2px
      border-color: $borderColor
  .break-down-btn
    font-size: 14px
    padding: 4px
  .meihen-icon
    font-size: 14px
    color: $baseRedColor
    border: 2px solid $baseRedColor
    border-radius: 8px
    padding: 5px
    margin-top: 10px
    width: 100px
  .irekae-icon
    font-size: 14px
    color: green
    border: 2px solid green
    border-radius: 8px
    padding: 5px
    margin-top: 10px
    width: 100px
  .camera-icon
    cursor: pointer
    font-size: 32px
    &:hover
      opacity: 0.8
// 画像一覧
.img-box
  position: relative
  input[type="checkbox"]
    position: absolute
    width: 24px
    height: 24px
    right: 0px

#brakedown-modal
  font-size: 18px
  width: $baseWidth * 0.4
#image-list-modal h5
  font-size: 0.9em
  margin-top: 30px !important
  margin-bottom: 30px !important
  background-color: #f2f2f2
  padding: 8px 16px  !important
  border-bottom: 0
  border-radius: 2px
  @include sp
    margin-top: 10px !important
    margin-bottom: 10px !important
#image-list-modal
  $modalWidth: $baseWidth * 0.7
  $imgWidth: $modalWidth * 0.222
  img
    border: solid 1px darkgray
    &:hover
      opacity: 0.8
  .d-inline img
    width: $imgWidth
    height: $imgWidth * 0.8
    object-fit: contain
  @include sp
    .d-inline img
      width: 45%
      height: 45%

.pen-btn
  padding: 0 5px
  font-size: 14px
  margin-bottom: 2px
.irekae-icon
  color: red
  border: 1px solid red
  width: 100px
  text-align: center
</style>

<style lang="sass">
@import '../../assets/css/logico2'
#image-detail-modal
  z-index: 12
  .img-wrapper
    width: 90%
    margin: 0 auto
    max-height: 700px
    overflow: scroll
    img
      max-width: 400px !important
      margin: 0 auto
</style>



// WEBPACK FOOTER //
// src/components/history/Index.vue